import React from 'react';
import '../style/DateTimeRange.css';
import PropTypes from 'prop-types';
import { addFocusStyle, darkTheme, lightTheme } from '../utils/StyleUtils';
import { Icon } from 'components/ui/icon';

class MonthYearSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      monthFocus: false,
      yearFocus: false,
    };

    this.monthFocus = this.monthFocus.bind(this);
    this.yearFocus = this.yearFocus.bind(this);
    this.monthBlur = this.monthBlur.bind(this);
    this.yearBlur = this.yearBlur.bind(this);
  }

  createCalendarMonths(months) {
    return this.mapToOption(months);
  }

  createYears(years) {
    return this.mapToOption(years);
  }

  monthFocus() {
    this.setState({ monthFocus: true });
  }

  monthBlur() {
    this.setState({ monthFocus: false });
  }

  yearFocus() {
    this.setState({ yearFocus: true });
  }

  yearBlur() {
    this.setState({ yearFocus: false });
  }

  mapToOption(variableArray) {
    return variableArray.map((varInstance, i) => (
      <option key={i}>{varInstance}</option>
    ));
  }

  createGlyph(icon, onClickHandler, previous, next) {
    return (
      <div
        style={{
          cursor: 'pointer',
          display: 'inline-flex',
          padding: '5px',
          userSelect: 'none',
        }}
        role='button'
        aria-label={icon === 'chevron-left' ? "Previous Month": "Next Month"}
        tabIndex={0}
        onClick={() => onClickHandler(previous, next)}
      >
        <Icon name={icon === 'chevron-left' ? 'chevron-left' : 'chevron-right'} size={18} />
      </div>
    );
  }

  render() {
    const months = this.createCalendarMonths(this.props.months);
    const years = this.createYears(this.props.years);
    const theme = this.props.darkMode ? darkTheme : lightTheme;

    const leftArrow = this.createGlyph(
      'chevron-left',
      this.props.changeMonthArrowsCallback,
      true,
      false
    );

    const rightArrow = this.createGlyph(
      'chevron-right',
      this.props.changeMonthArrowsCallback,
      false,
      true
    );

    const monthFocusStyle = addFocusStyle(this.state.monthFocus, {});
    const yearFocusStyle = addFocusStyle(this.state.yearFocus, {});

    return (
      <div className="monthYearContainer">
        <div className="multipleContentOnLine leftChevron">{leftArrow}</div>
        <div
          className="multipleContentOnLine"
          onFocus={this.monthFocus}
          onBlur={this.monthBlur}
          style={monthFocusStyle}
        >
          <select
            id={'MonthSelector_' + this.props.mode}
            value={this.props.months[this.props.month]}
            onChange={this.props.changeMonthCallback}
            style={theme}
            aria-label="Select Month"
          >
            {months}
          </select>
        </div>
        <div
          className="multipleContentOnLine"
          onFocus={this.yearFocus}
          onBlur={this.yearBlur}
          style={yearFocusStyle}
        >
          <select
            id={'YearSelector_' + this.props.mode}
            aria-label="Select Year"
            value={this.props.year}
            onChange={this.props.changeYearCallback}
            style={theme}
          >
            {years}
          </select>
        </div>
        <div className="multipleContentOnLine rightChevron">{rightArrow}</div>
      </div>
    );
  }
}

MonthYearSelector.propTypes = {
  months: PropTypes.array.isRequired,
  years: PropTypes.array.isRequired,
  month: PropTypes.number.isRequired,
  year: PropTypes.number.isRequired,
  changeMonthCallback: PropTypes.func.isRequired,
  changeYearCallback: PropTypes.func.isRequired,
  changeMonthArrowsCallback: PropTypes.func.isRequired,
  darkMode: PropTypes.bool,
};

export default MonthYearSelector;
